import {Tooltip, TooltipContent, TooltipTrigger} from "@/components/basic/tooltip";
import {useTranslationWithKeys} from "@/hooks/useTranslationWithKeys";
import {formatDate} from "@/utils/dateUtils";
import {getLicenseDisplayStatus, getLicenseExpirationDisplay, LicenseExpirationDisplay} from "@/utils/licenseUtils";
import {VwpLicense} from "@/store/generated/api";

interface LicenseExpirationLabelProps {
    license: VwpLicense;
    className?: string;
    tooltipMode?: 'default' | 'detailed';
}

export function LicenseExpirationLabel({
                                           license,
                                           className = "",
                                           tooltipMode = 'default'
                                       }: LicenseExpirationLabelProps) {
    const {t} = useTranslationWithKeys();
    const expirationDisplay: LicenseExpirationDisplay = getLicenseExpirationDisplay(license);
    const licenseStatus = getLicenseDisplayStatus(license);

    const textColorClass = licenseStatus === 'expired'
        ? 'text-red-600'
        : expirationDisplay.isExpiredSupport
        ? 'text-orange-600'
        : '';

    const dateDisplay = (
        <span className={textColorClass}>
            {formatDate(expirationDisplay.date)}
        </span>
    );

    if (tooltipMode === 'detailed') {
        return (
            <Tooltip>
                <TooltipTrigger asChild>
                    {dateDisplay}
                </TooltipTrigger>
                <TooltipContent>
                    <div className="space-y-1">
                        <div className="flex items-center gap-2">
                            <span className="font-medium">{t('licenses.expiration.software')}:</span>
                            <span>{license.softwareExpiration ? formatDate(license.softwareExpiration) : '-'}</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="font-medium">{t('licenses.expiration.support')}:</span>
                            <span>{license.supportExpiration ? formatDate(license.supportExpiration) : '-'}</span>
                        </div>
                    </div>
                </TooltipContent>
            </Tooltip>
        );
    }

    if (expirationDisplay.isExpiredSupport) {
        return (
            <Tooltip>
                <TooltipTrigger asChild>
                    {dateDisplay}
                </TooltipTrigger>
                <TooltipContent>
                    {t('licenses.expiredSupport.tooltip')}
                </TooltipContent>
            </Tooltip>
        );
    }

    return <span className={className}>{dateDisplay}</span>;
}
